import axios, { AxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { toAbsoluteUrl } from './_metronic/helpers'
import moment from 'moment'
import { deleteCookie, getCookie, setCookie } from './_metronic/assets/ts/components/CookieComponent'
import { useLocation } from 'react-router-dom'
import { usePermissions } from './app/pages/contexts/PermissionContext'

const Securitykey = process.env.REACT_APP_SECURITYKEY;


export const FONTS = {
  bold: 'Poppins-Bold',
  black: 'Poppins-Black',
  regular: 'Poppins-Regular',
  medium: 'Poppins-Medium',
  semiBold: 'Poppins-SemiBold',
  semiItalic: 'Poppins-SemiBoldItalic',
  mediumItalic: 'Poppins-MediumItalic',
  italic: 'Poppins-Italic',
}

export const getEncodedCookie = (key: any) => {
  const encryptedKey = encodeURIComponent(encrypt(key));
  const cookie = getCookie(encryptedKey);
  return cookie && decrypt(cookie);
};

export const deleteEncodedCookie = (key: any) => {
  const encryptedKey = encrypt(key);
  deleteCookie(encryptedKey);

  //   return cookie && decrypt(cookie);
};

export const checkValue = (value: any) => {
  if (value != "" && value != null && value != undefined) {
    return value;
  } else {
    return "";
  }
};

export const setEncodedCookie = (key: any, value: any) => {
  let formattedValue;

  switch (typeof value) {
    case "object":
      formattedValue = JSON.stringify(value);
      break;
    case "number":
      formattedValue = String(value);
      break;
    default:
      formattedValue = value;
      break;
  }

  setCookie(encrypt(key), encrypt(formattedValue), {});
};

export const KEYS = {
  google_key: 'AIzaSyBcCBh1wLrK0wX_kGxxW2XBsZYfyFB9-40',
  PayPal_Client_ID: '',
  PayPal_Secret_key1: '',
}

export const SIZE = {
  font_11: 11,
  font_13: 13,
  font_15: 15,
  font_17: 17,
  font_20: 20,
}

export const COLORS = {
  darkGray: '#9A9999',
  borderClr: '#E8E6EA',
  pink: '#CB6CE6',
  lightGray: '#F5F5F5',
}

export const URL = {
  uatgogagnerurl: process.env.REACT_APP_UAT_GOGAGNER_URL,
}


export const fetchFormData = async (url: string, raw: any) => {
  var myHeaders: any = new Headers()
  var myHeaders: any = {
    apitoken: process.env.REACT_APP_API_TOKEN,
  }

  var requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }

  let response = await fetch(URL.uatgogagnerurl + url, requestOptions)

  let json = await response.json()

  return json
}

const uploadImage = async (file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await axios.post(
      `${URL.uatgogagnerurl}vendor/public/descrptionImageUpload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (response.data.success) {
      return response.data.fileUrl // Adjust this based on your server response
    } else {
      console.error('Upload error:', response.data.message)
      return null
    }
  } catch (error) {
    console.error('Upload error:', error)
    return null
  }
}
export const config = (height?: number): any => {
  return {
    uploader: {
      insertImageAsBase64URI: false,
    },
    buttons: [
      'source',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
      '|',
      'ul',
      'ol',
      'outdent',
      'indent',
      '|',
      'font',
      'fontsize',
      'brush',
      'paragraph',
      '|',
      {
        name: 'image',
        exec: async function (editor: any) {
          const input = document.createElement('input') as any
          input.type = 'file'
          input.accept = 'image/*'
          input.onchange = async function () {
            const file = input.files[0]
            if (file) {
              const imageUrl = await uploadImage(file)
              if (imageUrl) {
                editor.selection.insertImage(imageUrl)
              }
            }
          }
          input.click()
        },
      },
      'table',
      'link',
      '|',
      'align',
      'undo',
      'redo',
      '|',
      'hr',
      'eraser',
      'copyformat',
      '|',
      'symbol',
      'fullsize',
      'print',
      'about',
    ],
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: 'middle',
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_clear_html',
    placeholder: '',

    // ✅ height param if provided, else fallback
    height: height ?? 300,
    minHeight: 200,
    maxHeight: 600,
  }
}

export const fetchData = async (url: string, raw: any, method: any = 'POST') => {
  var myHeaders: any = new Headers()
  var myHeaders: any = {
    apitoken: process.env.REACT_APP_API_TOKEN,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  var requestOptions: AxiosRequestConfig = {
    method: method,
    url: URL.uatgogagnerurl + url,
    headers: myHeaders,
    data: JSON.stringify(raw),
  }

  const response = await axios(requestOptions)

  let json = await response.data

  return json
}

export const fetchData2 = async (
  url: string,
  raw: any,
  method: AxiosRequestConfig['method'] = 'POST'
) => {
  const myHeaders = {
    apitoken: process.env.REACT_APP_API_TOKEN || '',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  const requestOptions: AxiosRequestConfig = {
    method,
    url: `${URL.uatgogagnerurl}${url}`,
    headers: myHeaders,
    data: raw,
  }

  try {
    const response = await axios(requestOptions)
    return response
  } catch (error) {
    console.error('API Error:', error)
    throw error // Re-throw to handle in the calling function
  }
}

export function toasterrormsg(message: any) {
  toast.error(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  })
}

export function toastsuccessmsg(message: any) {
  toast.success(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  })
}

export const truncateText = (text: any, maxLength = 10) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

export const dateFormat = (date: any) => {
  const inputDate = new Date(date)

  if (date != undefined && date != null && date == '') {
    const year = inputDate.getFullYear()
    const month =
      inputDate.getMonth() + 1 > 9 ? inputDate.getMonth() + 1 : '0' + (inputDate.getMonth() + 1)
    const day = inputDate.getDate() > 9 ? inputDate.getDate() : '0' + inputDate.getDate()

    return `${year}-${month}-${day}`
  } else {
    return ''
  }
}

export const autopassword = () => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+'
  let password = ''

  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    password += charset.charAt(randomIndex)
  }

  return password
}

export function checkImageExists(url: any) {
  fetch(url, { method: 'HEAD' })
    .then((response) => {
      if (response.ok) {
        return url
      } else {
        return toAbsoluteUrl('/media/avatars/300-1.jpg')
      }
    })
    .catch(() => {
      return toAbsoluteUrl('/media/avatars/300-1.jpg')
    })
}

export const isOnlyNumber = (value: any) => {
  // Regular expression to match only numbers
  const regex = /^[0-9]+$/
  // Check if the value contains only numbers
  if (!regex.test(value)) {
    // Check if the value contains any alphabetic characters
    if (/^[a-zA-Z]+$/.test(value)) {
      // Value contains alphabetic characters, return false
      return false
    }
  }
  // Value contains only numbers or only alphabetic characters
  return true
}
export const isAlfabetsWithSpace = (value: any) => {
  // Regular expression to match only numbers
  const regex = /^[a-zA-Z ]+$/
  // Check if the value contains only numbers
  if (!regex.test(value)) {
    // Check if the value contains any alphabetic characters
    if (/^[0-9]+$/.test(value)) {
      // Value contains alphabetic characters, return false
      return false
    }
  }
  // Value contains only numbers or only alphabetic characters
  return true
}

export const hasSpecialCharacters = (value: any) => {
  // Regular expression to match special characters excluding spaces and English, Russian, and Uzbek language characters
  const specialCharacterRegex =
    /[^\w\u0020\u002C\u0430-\u044F\u0410-\u042F\u0401\u0451\u0493\u049B\u04E9\u04EF\u0513\u051B\u0523\u052B\u0533\u053B]/
  // Test if the value contains any special characters
  return !specialCharacterRegex.test(value)
}


// export const checkLanguage = (language:any , english:any , russian:any , uzbek:any ) => {
//  if(language === 'english') {
//   return english
//  }else if(language === 'russian') {
//   return russian
//  }else if(language === 'uzbek') {
//   return uzbek  }
// }


export const isOnlyAlphabetic = (value: any) => {
  // Regular expression to match only alphabetic characters and space
  const regex = /^[a-zA-Z\s]+$/
  // Check if the value contains only alphabetic characters and space
  return regex.test(value)
}

export const isSpecificSpecialCharacters = (value: any, customRegex?: RegExp) => {
  // Default regex (existing behavior)
  const defaultRegex = /^[a-zA-Z<>,."'*() ]*$/;

  // Use custom regex if provided, else default
  const regexToUse = customRegex || defaultRegex;

  return regexToUse.test(value);
};
export const limitLength = (value: any, maxLength: any) => {
  if (value.length <= maxLength) {
    return value // If the value is within the limit, return it unchanged
  } else {
    return value.slice(0, maxLength) + '...' // Otherwise, return a portion of the value with ellipsis
  }
}

export const googleMapKey = process.env.REACT_APP_GOOGLE_KEY

export function mysql_real_unescape_string(str: any): any {
  if (typeof str !== 'string') {
    return str
  } else {
    return str.replace(
      /\\0|\\b|\\t|\\z|\\n|\\r|\\"|\\'|\\\\|\\%/g,
      function (char: string): string {
        switch (char) {
          case '\\0':
            return '\0'
          case '\\b':
            return '\x08'
          case '\\t':
            return '\x09'
          case '\\z':
            return '\x1a'
          case '\\n':
            return '\n'
          case '\\r':
            return '\r'
          case '\\"':
            return '"'
          case "\\'":
            return "'"
          case '\\\\':
            return '\\'
          case '\\%':
            return '%'
          default:
            return char // return the char if it doesn't match any case
        }
      }
    )
  }
}

// export const formatNumber = (number: any) => {
//   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
// }

export const checkwithremovemonth = (value: any, oldvalue: any) => {
  if (value.match(/^\d+$/) || value == '') {
    value = value.replace(/^0+(?=\d)/, '') || 0
    return value
  }
  return oldvalue
}

export const formatNumber = (number: any) => {

  if (number == null || number == undefined || isNaN(number)) {
    return '0 UZS'
  }
  const [integerPart, decimalPart] = number.toString().split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return decimalPart
    ? `${formattedInteger}.${decimalPart.slice(0, 2)} UZS`
    : formattedInteger + ' UZS'
}

export const getNumberOfDays = (fromDate: any, toDate: any) => {
  const start = moment(fromDate)
  const end = moment(toDate)
  // Calculate the difference in days
  const duration = end.diff(start, 'days')
  return duration
}
export const getNumberOfHours = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'HH:mm:ss')
  const end = moment(toTime, 'HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursWithDateRange = (
  fromDate: string,
  fromTime: string,
  toDate: string,
  toTime: string
) => {
  const start = moment(`${fromDate} ${fromTime}`, 'YYYY-MM-DD HH:mm:ss')
  const end = moment(`${toDate} ${toTime}`, 'YYYY-MM-DD HH:mm:ss')

  // Calculate total duration in hours (can include fractions)
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursFromDateTime = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'YYYY-MM-DD HH:mm:ss')
  const end = moment(toTime, 'YYYY-MM-DD HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}
export const getNumberOfHoursTime = (fromTime: any, toTime: any) => {
  const start = moment(fromTime, 'HH:mm:ss')
  const end = moment(toTime, 'HH:mm:ss')

  // Calculate the difference in hours
  const duration = end.diff(start, 'hours', true)

  return duration
}

export const handleTimeChange = (date: any, roundingInterval = 15) => {
  if (date && date.length > 0) {
    const selectedTime = moment(date[0]) // Get the first element if date is an array
    if (selectedTime.isValid()) {
      const roundedTime = selectedTime
        .minute(Math.round(selectedTime.minute() / roundingInterval) * roundingInterval)
        .second(0)
      return roundedTime.format('HH:mm') // Return the rounded time
    } else {
      console.error('Invalid date selected')
    }
  }
  return '00:00' // Return null if no valid date is selected
}


export function encryptAndEncode(input: string): string {
  return encodeURIComponent(encrypt(input));
}

export function decryptAndDecode(input: any): string {
  return decodeURIComponent(decrypt(input));
}


export const formatDate = (date: any, format: any) => {
  return moment(date).format(format)
}

export const formatDatePublic = (date: any) => {
  return moment(date).format("DD-MM-YYYY hh:mm A");
};

export const formattedMessage = (text: string): string => {
  return text.replace(/\n/g, '<br/>')
}

export const eLevel: any = {
  0: {
    "key": false,
    "value": false
  },
  1: {
    "key": false,
    "value": true
  },
  2: {
    "key": true,
    "value": true
  },
  3: {
    "key": true,
    "value": false
  },
}



// get translation values

export const getTranslatedValue = (lang: any, propertyType: any, suffix: any, overridePrimaryLang?: any) => {
  const primaryToCode: any = {
    "English": "en",
    "Russian": "ru",
    "Uzbek": "uz"
  };
  const preferredKey = `${lang}${suffix}`;
  if (propertyType[preferredKey]) return propertyType[preferredKey];

  // Only fallback if primaryLanguage exists and is valid
  const primaryLang = overridePrimaryLang ?? propertyType.primaryLanguage ?? '';
  if (primaryLang && primaryToCode[primaryLang]) {
    const primaryCode = primaryToCode[primaryLang];
    const fallbackKey = `${primaryCode}${suffix}`;
    return propertyType[fallbackKey] || "";
  }
  // Directly return empty if no valid primaryLanguage
  return "";
};

// export const getEncryptedRoute = (
//   path: string,
//   data: Record<string, any>, // accept any key-value object
//   level: keyof typeof eLevel = '2'
// ): string => {
//   const encrypted = encryptObject(data, eLevel[level])
//   const encoded = encodeURIComponent(JSON.stringify(encrypted))
//   return `${path}?data=${encoded}`
// }


export const getEncryptedRoute = (
  path: string,
  data: Record<string, any>,
): string => {
  try {
    // Convert object to JSON string
    const jsonString = JSON.stringify(data);

    // Encrypt the JSON string
    const encrypted = encrypt(jsonString);

    // Return path with encrypted data as query parameter
    return `${path}?data=${encodeURIComponent(encrypted)}`;
  } catch (error) {
    console.error("Failed to encrypt route data:", error);
    return path; // Return plain path on error
  }
};



export const useMenuIdPermissions = (level: keyof typeof eLevel = '2') => {
  const location = useLocation()
  const { permissions } = usePermissions() as any
 
  const queryParams = new URLSearchParams(location.search)
  const encryptedData = queryParams.get('data')

  let decryptedData: Record<string, any> = {}
 if (encryptedData) {
    try {
      // Decrypt the URL-safe base64 string
      const decryptedString = decrypt(decodeURIComponent(encryptedData));

      // Parse the JSON string back to object
      decryptedData = JSON.parse(decryptedString);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  const menuId = decryptedData?.menuId

  return {
    urlData: decryptedData, // expose full data as `data`
    menuId,
    menuIdAdd: menuId && permissions?.menuIdAdd?.includes(menuId),
    menuIdEdit: menuId && permissions?.menuIdEdit?.includes(menuId),
    menuIdDelete: menuId && permissions?.menuIdDelete?.includes(menuId),
    menuIdView: menuId && permissions?.menuIdView?.includes(menuId),
  }
}

export const findMenuWithParent = (
  menus: any[],
  targetPath: string,
  parent: any = null
): { menu: any; parent: any } | null => {

  const normalizedTarget = targetPath.trim();

  for (const menu of menus) {

    if (menu.path?.trim() === normalizedTarget) {
      return { menu, parent };
    }

    if (menu.submenu?.length) {
      const found = findMenuWithParent(menu.submenu, targetPath, menu);
      if (found) return found;
    }
  }

  return null;
};


export const startPolling = (
  callback: () => void,
  interval: number
) => {
  let pollingInterval: NodeJS.Timeout | null = null;

  const adminData: any = sessionStorage.getItem("admin");
  let adminId = "";
  if (adminData) {
    adminId = JSON.parse(adminData).adminId || "";
  }

  const runCheck = () => {
    if (document.visibilityState === "visible" && adminId) {
      callback();
    }
  };

  const start = () => {
    runCheck(); // Run immediately
    pollingInterval = setInterval(runCheck, interval);
  };

  const stop = () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  };

  // Stop polling when tab becomes hidden
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      stop();
    } else {
      start();
    }
  });

  start();

  return stop; // Allows manual stop if needed
};


/**
 * Converts Uint8Array to URL-safe Base64 string.
 * Works in both Node.js and browser environments.
 * @param {Uint8Array} bytes - The bytes to encode.
 * @returns {string} - URL-safe Base64 string.
 */
const toUrlSafeBase64 = (bytes: any) => {
  let base64;
  if (typeof Buffer !== "undefined") {
    // Node.js environment
    base64 = Buffer.from(bytes).toString("base64");
  } else {
    // Browser environment
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    base64 = btoa(binary);
  }
  // Convert to URL-safe Base64: replace + with -, / with _, remove padding =
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

/**
 * Converts URL-safe Base64 string to Uint8Array.
 * Works in both Node.js and browser environments.
 * @param {string} base64 - URL-safe Base64 string.
 * @returns {Uint8Array} - Decoded bytes.
 */
const fromUrlSafeBase64 = (base64: any) => {
  // Convert from URL-safe Base64: replace - with +, _ with /, add padding
  let standardBase64 = base64.replace(/-/g, "+").replace(/_/g, "/");
  while (standardBase64.length % 4 !== 0) {
    standardBase64 += "=";
  }

  let binary;
  if (typeof Buffer !== "undefined") {
    // Node.js environment
    binary = Buffer.from(standardBase64, "base64").toString("binary");
  } else {
    // Browser environment
    binary = atob(standardBase64);
  }

  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

/**
 * Encrypts text using XOR + URL-safe Base64.
 * Handles all Unicode characters (UTF-8) and is URL/browser-friendly.
 * @param {string} text - The plaintext to encrypt.
 * @returns {string} - Encrypted text (URL-safe Base64 format).
 */
export const encrypt = (text: any) => {
  const key = Securitykey || "";
  // Convert text to UTF-8 bytes using TextEncoder (handles all Unicode)
  const encoder = new TextEncoder();
  const textBytes = encoder.encode(String(text));
  const keyBytes = encoder.encode(key);

  // XOR each byte with the key
  const encrypted = new Uint8Array(textBytes.length);
  for (let i = 0; i < textBytes.length; i++) {
    encrypted[i] = textBytes[i] ^ keyBytes[i % keyBytes.length];
  }

  return toUrlSafeBase64(encrypted);
};
/**
 * Decrypts URL-safe Base64 + XOR encrypted text.
 * Handles all Unicode characters (UTF-8) and is URL/browser-friendly.
 * @param {string} encryptedText - The encrypted text in URL-safe Base64 format.
 * @returns {string} - Decrypted plaintext.
 */
export const decrypt = (encryptedText: any) => {
  const key = Securitykey || "";
  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(key);

  // Decode URL-safe Base64 to bytes
  const encryptedBytes = fromUrlSafeBase64(String(encryptedText));

  // XOR each byte with the key to decrypt
  const decrypted = new Uint8Array(encryptedBytes.length);
  for (let i = 0; i < encryptedBytes.length; i++) {
    decrypted[i] = encryptedBytes[i] ^ keyBytes[i % keyBytes.length];
  }

  // Convert bytes back to string using TextDecoder (handles all Unicode)
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(decrypted);
};

/**
 * Encrypts an object or array based on provided encryption levels.
 * @param {object|Array} data - The object or array to encrypt
 * @param {object} keyLevel - Encryption level object with 'key' and 'value' properties
 * @returns {object|Array} - Encrypted result
 */
export const encryptData = (data: any, keyLevel: any) => {
  // If data is not an object/array, return as is.
  if (data === null || typeof data !== "object") return data;

  const { key: isKeyEncrypted, value: isValueEncrypted } = keyLevel;

  // Create the root container depending on data type.
  const root = Array.isArray(data) ? [] : {};
  // Stack items: { orig: original data, copy: new container }
  const stack = [{ orig: data, copy: root }];

  while (stack.length) {
    const { orig, copy }: any = stack.pop();

    if (Array.isArray(orig)) {
      // Process array elements.
      for (let i = 0; i < orig.length; i++) {
        const item = orig[i];
        if (Array.isArray(item)) {
          const newArr = [] as any;
          copy[i] = newArr;
          stack.push({ orig: item, copy: newArr });
        } else if (item instanceof Date) {
          copy[i] = isValueEncrypted
            ? encrypt(item.toISOString())
            : item.toISOString();
        } else if (item !== null && typeof item === "object") {
          const newObj = {};
          copy[i] = newObj;
          stack.push({ orig: item, copy: newObj });
        } else if (typeof item === "string") {
          copy[i] = isValueEncrypted ? encrypt(item) : item;
        } else {
          copy[i] = item;
        }
      }
    } else {
      // Process object properties.
      for (const origKey in orig) {
        if (Object.prototype.hasOwnProperty.call(orig, origKey)) {
          // Encrypt the key if required.
          const newKey = isKeyEncrypted ? encrypt(String(origKey)) : origKey;
          const val = orig[origKey];

          if (Array.isArray(val)) {
            const newArr = [] as any;
            copy[newKey] = newArr;
            stack.push({ orig: val, copy: newArr });
          } else if (val instanceof Date) {
            copy[newKey] = isValueEncrypted
              ? encrypt(val.toISOString())
              : val.toISOString();
          } else if (val !== null && typeof val === "object") {
            const newObj = {};
            copy[newKey] = newObj;
            stack.push({ orig: val, copy: newObj });
          } else if (typeof val === "string") {
            copy[newKey] = isValueEncrypted ? encrypt(val) : val;
          } else {
            copy[newKey] = val;
          }
        }
      }
    }
  }

  return root;
};

/**
 * Decrypts an object or array based on provided decryption levels.
 * @param {object|Array} data - The encrypted object or array to decrypt
 * @param {object} keyLevel - Decryption level object with 'key' and 'value' properties
 * @returns {object|Array} - Decrypted result
 */
export const decryptData = (data: any, keyLevel: any) => {
  // If data is not an object/array, return as is.
  if (data === null || typeof data !== "object") return data;

  const { key: isKeyEncrypted, value: isValueEncrypted } = keyLevel;

  // Create the root container depending on data type.
  const root = Array.isArray(data) ? [] : {};
  // Stack items: { orig: encrypted data, copy: new container }
  const stack = [{ orig: data, copy: root }];

  while (stack.length) {
    const { orig, copy }: any = stack.pop();

    if (Array.isArray(orig)) {
      // Process array elements.
      for (let i = 0; i < orig.length; i++) {
        const item = orig[i];
        if (Array.isArray(item)) {
          const newArr = [] as any;
          copy[i] = newArr;
          stack.push({ orig: item, copy: newArr });
        } else if (typeof item === "string") {
          copy[i] = isValueEncrypted ? decrypt(item) : item;
        } else if (item !== null && typeof item === "object") {
          const newObj = {};
          copy[i] = newObj;
          stack.push({ orig: item, copy: newObj });
        } else {
          copy[i] = item;
        }
      }
    } else {
      // Process object properties.
      for (const origKey in orig) {
        if (Object.prototype.hasOwnProperty.call(orig, origKey)) {
          // Decrypt the key if required.
          const newKey = isKeyEncrypted ? decrypt(String(origKey)) : origKey;
          const val = orig[origKey];

          if (Array.isArray(val)) {
            const newArr = [] as any;
            copy[newKey] = newArr;
            stack.push({ orig: val, copy: newArr });
          } else if (typeof val === "string") {
            copy[newKey] = isValueEncrypted ? decrypt(val) : val;
          } else if (val !== null && typeof val === "object") {
            const newObj = {};
            copy[newKey] = newObj;
            stack.push({ orig: val, copy: newObj });
          } else {
            copy[newKey] = val;
          }
        }
      }
    }
  }

  return root;
};
